
import FileInput from "../../../common/input/FileInput";

export default function FieldImage({ onChange }) {
	return <FileInput onChange={onChange} label="تصویر جلسه" />;
}
